import { __styles, mergeClasses } from '@griffel/react';
import { useOptionStyles_unstable } from '@fluentui/react-combobox';
export const tagPickerOptionClassNames = {
  root: 'fui-TagPickerOption',
  media: 'fui-TagPickerOption__media',
  secondaryContent: 'fui-TagPickerOption__secondaryContent'
};
/**
 * Styles for the root slot
 */
const useStyles = /*#__PURE__*/__styles({
  root: {
    mc9l5x: "f13qh94s",
    Budl1dq: "fjxzuw",
    Bt984gj: "f122n59"
  },
  secondaryContent: {
    Br312pm: "fd46tj4",
    Ijaq50: "faunodf"
  },
  media: {
    Ijaq50: "fldnz9j"
  }
}, {
  d: [".f13qh94s{display:grid;}", ".fjxzuw{grid-template-columns:auto 1fr;}", ".f122n59{align-items:center;}", ".fd46tj4{grid-column-start:2;}", ".faunodf{grid-row-start:2;}", ".fldnz9j{grid-row-start:span 2;}"]
});
/**
 * Apply styling to the TagPickerOption slots based on the state
 */
export const useTagPickerOptionStyles_unstable = state => {
  'use no memo';

  useOptionStyles_unstable({
    ...state,
    active: false,
    disabled: false,
    focusVisible: false,
    checkIcon: undefined,
    selected: false
  });
  const styles = useStyles();
  state.root.className = mergeClasses(tagPickerOptionClassNames.root, styles.root, state.root.className);
  if (state.media) {
    state.media.className = mergeClasses(tagPickerOptionClassNames.media, styles.media, state.media.className);
  }
  if (state.secondaryContent) {
    state.secondaryContent.className = mergeClasses(tagPickerOptionClassNames.secondaryContent, styles.secondaryContent, state.secondaryContent.className);
  }
  return state;
};